module.exports = __webpack_public_path__ + "static/media/ic_mask_start.2f376984.svg";